import { render, staticRenderFns } from "./RequestPasswordRestoreModal.vue?vue&type=template&id=3b12880c"
import script from "./RequestPasswordRestoreModal.vue?vue&type=script&lang=js"
export * from "./RequestPasswordRestoreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports